import React, { Component } from 'react';
import './App.css';
import Contact from './components/Contact'
import Results from './components/Results'
import Rest from './components/Rest'
import { Navigation, About,Home , GameDikha }  from './components';
import {Main} from './components'

class App extends Component {


  render() {
    return (
      <div>
      
        <Navigation />
        <div>
        <GameDikha/>
        <Home/>
        <About/>
        <Rest/>
        <Results/>
        <Contact/>
        
        </div>
        

      </div>
    );
  }
}

export default App;
